<template>
  <v-card>
    <v-card-title>
      <span class="section-title">{{ cardTitle }}</span>
      <v-spacer />
      <export-data :disabled="!hasPiiAccess" :data-fetcher="getDataToExport" :filename="logTitle" ghost />
    </v-card-title>
    <infinite-scroll v-model="loading" scrollType="box" :percentualUpdate="90" @update-data="loadMoreLogs">
      <v-card-text v-if="logsData.length > 0" class="logs-content">
        <v-row v-for="(log, index) in logsData" :key="index" class="pa-3">
          <log-summary-card :log="log" @select-log="selectLog" />
        </v-row>
      </v-card-text>
      <v-card-text v-else-if="loading"></v-card-text>
      <v-card-text v-else>
        <v-row justify="center" align="center" class="emphasis-box">
          <p class="texto-corrido mb-0">Não há dados</p>
        </v-row>
      </v-card-text>
    </infinite-scroll>
    <v-card-actions>
      <mf-action-buttons
        class="mr-2 pb-2"
        :primary-button="{
          text: 'Fechar',
          action: closeModal,
          isVisible: true,
        }"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { QUERY_LIST_LOGS } from './graphql'
import { utilsMixin } from './mixins/utils'
import ExportData from '@/components/export-data/ExportData.vue'

export default {
  name: 'LogsModal',
  components: {
    InfiniteScroll: () => import('@/components/InfiniteScroll.vue'),
    ExportData,
    LogSummaryCard: () => import('./LogSummaryCard.vue'),
  },
  mixins: [utilsMixin],
  props: {
    tags: {
      type: String,
      required: true,
    },
    logTitle: {
      type: String,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
    idItem: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    pageNumber: 1,
    records: 0,
    logsData: [],
  }),
  mounted() {
    this.getLogsData()
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    selectLog(log) {
      this.$emit('select-log', log)
    },
    loadMoreLogs() {
      if (this.records === this.logsData.length) return

      this.pageNumber += 1
      this.getLogsData()
    },
    getDataToExport() {
      try {
        const rows = this.logsData.map((currentLog) => [currentLog.user.name, this.formatDate(currentLog.created_at)])
        const headers = ['usuario', 'data e hora']
        return { headers, rows }
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao exportar .csv', snackbarColor: 'error' })
      }
    },
    getLogsData() {
      this.loading = true
      this.$apollo
        .query({
          query: QUERY_LIST_LOGS,
          variables: {
            fieldFilters: {
              key: '_id',
              value: this.idItem,
            },
            tags: [this.tags],
            page: this.pageNumber,
            pageSize: 10,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { operationLogs } }) => {
          this.loading = false
          this.logsData.push(...operationLogs.operationLogs)
          this.records = operationLogs.records
          this.pageNumber = operationLogs.page
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
          this.$snackbar({ message: 'Erro ao buscar dados.' })
        })
    },
  },
}
</script>

<style lang="scss">
.info-text {
  font-size: 16px;
  color: $cinza-0;
  &__bold {
    font-weight: 700;
  }
}
.empashis-title {
  font-size: 18px;
  color: $cinza-d10;
}
.emphasis-box {
  background-color: $cinza-l90;
  border-radius: 5px;
  padding: 15px;
}
</style>
